import { plateConverter } from './demoPlate'
import { plateImagingTimepointConverter } from './demoTimepoint'
import { wellConverter } from './demoWell'

const converters = {
  plates: plateConverter,
  wells: wellConverter,
  timepoints: plateImagingTimepointConverter,
}

export default converters
